import React from "react";
import { Redirect } from "react-router-dom";
import { Button, Header } from "semantic-ui-react";
import styled from "styled-components";
import { ErrorMessages } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import MainContentWrapper from "./common/MainContentWrapper";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import ErrorDisplay from "./ErrorDisplay";
import { Dimmer, Icon } from "semantic-ui-react";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 100;
`;

const HeaderText = styled.div`
  font-size: 16px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 20px;
  text-align: center;
`;

class ConfirmEmail extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      redirectPage: null,
      redirectState: null,
      showSuccess: false,
      showFailure: false,
      loaderActive: false,
      showActivityIndicator: false,
    };
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPage ? (
          <Redirect
            to={{
              pathname: this.state.redirectPage,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Email Confirmation" />
        <MainContentWrapper>
          <Wrapper>
          {!this.state.showSuccess && !this.state.showFailure && (
              <Header
                as="h2"
                color="black"
                textAlign="center"
                style={{ fontSize: "20px" }}
              >
                Confirming your email...
                <br />
              </Header>
            )}
            {this.state.showSuccess ? (
              <Header
                as="h2"
                color="black"
                textAlign="center"
                style={{ fontSize: "20px" }}
              >
                Thank you for confirming your email.
                <br />
                You may now return to continue the registration process.
                <br />
              </Header>
            ) : null}
            {this.state.showFailure ? (
              <Header
                as="h2"
                color="black"
                textAlign="center"
                style={{ fontSize: "20px" }}
              >
                There was a problem confirming your email. Please click the
                button below to resend the email invitation.
                <br />
                <Button
                  primary
                  onClick={() =>
                    this.identityApi.sendConfirmationEmail(this.params.email)
                  }
                >
                  Resend Confirmation
                </Button>
              </Header>
            ) : null}
            {this.errorManager.getErrorCount() > 0 ? (
              <ErrorDisplay errorManager={this.errorManager} />
            ) : null}

          </Wrapper>
        </MainContentWrapper>
      </SiteWrapper>
    );
  }

  async componentDidMount() {
    console.log("In confirm email");
    try {
      if (!this.params.email) {
        this.errorManager.addError(ErrorMessages.MISSING_EMAIL_PARAMETER);
        this.forceUpdate();
        return;
      }
      if (!this.params.token) {
        this.errorManager.addError(ErrorMessages.MISSING_TOKEN_PARAMETER);
        this.forceUpdate();
        return;
      }
      this.setState({ loaderActive: true });
      const response = await this.identityApi.confirmEmail(
        this.params.email,
        this.params.token
      );
      if (response.data) {
        this.setState({
          showSuccess: true,
        });
      } else {
        this.setState({
          showFailure: true,
        });
      }
    } catch (err) {
      this.errorManager.addError(ErrorMessages.FAILED_TO_CONFIRM_EMAIL);
      this.forceUpdate();
      console.log(err);
    }
    this.setState({ loaderActive: false });
  }
}

export default ConfirmEmail;
